import React from 'react'
import { ButtonExportExcelStyle } from './style'

type ButtonExportExcelProps = React.FC<{
  onClick: () => void
  loadingGenerateExcel: boolean
}>

export const ButtonExportExcel: ButtonExportExcelProps = ({ onClick, loadingGenerateExcel }) => {
  return (
    <ButtonExportExcelStyle>
      {!loadingGenerateExcel ? (
        <button onClick={onClick}>
          <img src="/images/icons/iconDonwload.svg" alt="ícone de download" /> Exportar Excel
        </button>
      ) : (
        <button disabled>
          <img src="/images/icons/iconDonwload.svg" alt="ícone de download" /> Aguarde...
        </button>
      )}
    </ButtonExportExcelStyle>
  )
}
